import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useBrand } from '../../contexts/BrandContext';
const included = ['Your doctor, and a plan written for you', 'A 62-marker blood panel every year', 'Medication from a named US pharmacy', 'Retests and dose changes', 'Free shipping, cold-packed when it needs to be'];
const excluded = ['A dispensing fee bolted on at the end', 'Charges for asking your doctor a question', 'Dose increases you did not agree to', 'Twelve-month contracts and retention calls', 'Grey-market vials with no paperwork'];
export function Transparency() {
  const {
    brand
  } = useBrand();
  return <section className="bg-cream" data-id="element-117" data-mp="9t8ihnr1df9i">
      <div className="mx-auto max-w-shell px-6 py-16 md:px-8 md:py-24" data-id="element-118" data-mp="9s78lmlraytd">
        <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-119" data-mp="3i8s88csi0fjt">
          <div data-id="element-120" data-mp="3daqnzojc6a6r">
            <p className="text-[0.6875rem] uppercase tracking-label text-brick" data-id="element-121" data-mp="3db8tzcvsw2rv">Pricing</p>
            <h2 className="mt-3 font-serif text-3xl font-bold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-122" data-mp="3tu28gluvid44">
              The price is the price.
            </h2>
            <p className="mt-5 max-w-md text-base leading-relaxed text-ink-soft" data-id="element-123" data-mp="2kwh4hk64xbg">
              What you pay {brand.name} for care and what you pay for medication are two different
              numbers, and you see both before you start. Whatever you agree to today is what you
              pay twelve months from now, at any dose.
            </p>
            <Link to="/pricing" className="mt-7 inline-flex rounded-full border border-ink/20 px-5 py-2.5 text-sm text-ink transition-colors duration-150 ease-republic hover:border-ink hover:bg-ink hover:text-cream" data-id="element-124" data-mp="3fuu47ejuset2">
              See what things cost
            </Link>
          </div>

          <div className="grid gap-6 md:grid-cols-2" data-id="element-125" data-mp="102de5kyszval">
            <div className="rounded-brand border border-ink/10 bg-cream-light p-6" data-id="element-126" data-mp="143gs21xajh96">
              <h3 className="text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-127" data-mp="314md7mt6w18u">
                What you get
              </h3>
              <ul className="mt-5 flex flex-col gap-4" data-id="element-128" data-mp="2w4zy17tswaxe">
                {included.map(item => <li key={item} className="flex items-start gap-3" data-id="element-129" data-mp="3a49fsbxnnd3h">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brick" strokeWidth={2.25} data-id="element-130" data-mp="355y03kkoi8dc" />
                    <span className="text-sm leading-relaxed text-ink-soft" data-id="element-131" data-mp="2hgdfyycsh52h">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div className="rounded-brand border border-ink/10 bg-cream p-6" data-id="element-132" data-mp="2ddgtuxo1iqts">
              <h3 className="text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-133" data-mp="2r7zq0rde4y3n">
                What you will never get
              </h3>
              <ul className="mt-5 flex flex-col gap-4" data-id="element-134" data-mp="1ypvsp9aq71oi">
                {excluded.map(item => <li key={item} className="flex items-start gap-3" data-id="element-135" data-mp="1truaeql4j6e3">
                    <MinusIcon className="mt-0.5 h-4 w-4 shrink-0 text-stone" strokeWidth={2.25} data-id="element-136" data-mp="1tpgg4jy9py7l" />
                    <span className="text-sm leading-relaxed text-ink-muted" data-id="element-137" data-mp="97fctm43syxv">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}